export const SET_TAGS = "SET_TAGS"
export const SET_DISPLAY_FILTERS = "SET_DISPLAY_FILTERS"
export const SET_SCROLL = "SET_SCROLL"
